var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRokuLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 495.74 146.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#662d91;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RokuLogo5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.28,425.69H113.7l-34.63-48H67.42v47.92H29v-144h55c31.72,0,57.63,21.58,57.63,48.12,0,16.2-9.93,30.67-25,39.51l40.64,56.47m-54-96a24.08,24.08,0,0,0-24-24.18H67.42v48.16H79.3A24.06,24.06,0,0,0,103.26,329.71Z",
    transform: "translate(-29.02 -281.59)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.73,369.22a59,59,0,1,1-59.13-58.73,58.85,58.85,0,0,1,59.13,58.73M200.6,338.35c-10.18,0-18.78,13.83-18.78,30.87s8.6,30.85,18.78,30.85c10.37,0,19-13.8,19-30.85S211,338.35,200.6,338.35Z",
    transform: "translate(-29.02 -281.59)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.88,312.88l-44.25,44.27V312.76H267.2V425.57h38.43V379.8l46.21,45.77h48.32l-58.7-58.73,48.64-48.62v67c0,22.25,13.34,42.74,47,42.74,16,0,30.63-9.07,37.75-17.26l17.29,14.89h8.18V312.88H462v73c-4.33,7.55-10.37,12.31-19.67,12.31-9.47,0-13.8-5.62-13.8-23.53V312.88Z",
    transform: "translate(-29.02 -281.59)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M517.17,326.28a7.59,7.59,0,1,1,7.59-7.59A7.59,7.59,0,0,1,517.17,326.28Zm0-14.43a6.84,6.84,0,1,0,6.84,6.84A6.85,6.85,0,0,0,517.17,311.85Z",
    transform: "translate(-29.02 -281.59)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M513.9,314.84h3.43a3.06,3.06,0,0,1,2.22.77,2.32,2.32,0,0,1,.64,1.66v0a2.3,2.3,0,0,1-1.83,2.33l2.08,2.92h-1.6l-1.9-2.69h-1.69v2.69H513.9Zm3.33,3.82c1,0,1.58-.51,1.58-1.29v0c0-.83-.59-1.28-1.59-1.28h-2v2.59Z",
    transform: "translate(-29.02 -281.59)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRokuLogo);
export default __webpack_public_path__ + "static/media/RokuLogo.69a146cdc561e34c12faf5e48bdbe14f.svg";
export { ForwardRef as ReactComponent };